import { Star } from "lucide-react";

export default function Stars({ value = 0, onChange, size = 16, className = "" }) {
  const interactive = typeof onChange === "function";
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid="stars">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          onClick={interactive ? () => onChange(n) : undefined}
          style={{ width: size, height: size }}
          className={`${n <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-muted-foreground/40"} ${interactive ? "cursor-pointer hover:scale-110 transition-transform" : ""}`}
        />
      ))}
    </div>
  );
}

export function RatingLabel({ rating, className = "" }) {
  if (!rating || !rating.count) return <span className={`text-xs text-muted-foreground ${className}`}>Nessuna recensione</span>;
  return (
    <span className={`inline-flex items-center gap-1.5 text-sm ${className}`}>
      <Stars value={rating.average} size={14} />
      <span className="font-medium">{rating.average}</span>
      <span className="text-muted-foreground text-xs">({rating.count})</span>
    </span>
  );
}
